
































































































import mixins from "vue-typed-mixins";
import { GeneralMixin } from "@/mixins/general-mixin";
import Snackbar from "@/components/general/snackbar.vue";
import FooterGeneralNoBg from "@/components/general/footer-general-no-bg.vue";

export default mixins(GeneralMixin).extend({
  name: "Login",
  components: {
    Snackbar,
    FooterGeneralNoBg,
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      rules: {
        required: (value: any) => !!value || "Obrigatório!",
        email: (value: any) =>
          !this.isEmailValid(value)
            ? (this.$t(`errors.${this.error_message.invalid_email}`) as string)
            : true,
      },
      isRecovery: false,
    };
  },
  mounted() {
    const query = this.$route.query;
    const { demo, authorization } = query;

    if (!demo || demo !== "true") return;

    if (demo === "true") {
      const decodedAuth = atob(authorization as string);
      if (!decodedAuth) return;

      const m = decodedAuth.match(/^([^:]*):(.*)$/);
      if (!m) return;

      const [, email, password] = m;
      const isSmartEnergyLabEmail =
        /^[A-Za-z0-9._%+-]+@smartenergylab\.[A-Za-z]{2,}$/i.test(email.trim());

      if (!email || !password || !isSmartEnergyLabEmail) {
        return this.$store.dispatch("toggleSnackbar", {
          show: true,
          message: this.$t(`errors.${this.error_message.invalid_demo_user}`),
        });
      }

      const data = {
        email: email,
        password: password,
      };
      return this.$store.dispatch("login", data);
    }
  },
  methods: {
    async postLoginForm(): Promise<any> {
      await this.$store.dispatch("toggleSnackbar", null);
      if (this.form.validate()) {
        this.loading = true;
        const data = { email: this.email, password: this.password };
        return this.$store.dispatch("login", data).then(() => {
          this.loading = false;
        });
      } else {
        return this.$store.dispatch("toggleSnackbar", {
          show: true,
          message: this.$t(`errors.${this.error_message.form_has_error}`),
        });
      }
    },
  },
});
